module.exports = __webpack_public_path__ + "img/registration_at_schema_back.dc11850e.svg";